import { PageActionType } from './page-action-type';

export interface SetPageContentAction<T = {}> {
  type: PageActionType.SetPageContent;
  pageKey: string;
  content: T;
}

export const setPageContent = <T = {}>(
  pageKey: string,
  content: T,
): SetPageContentAction<T> => ({
  content,
  pageKey,
  type: PageActionType.SetPageContent,
});
